// extracted by css-extract-rspack-plugin
export default {"sidePanel":"sidePanel-B2SFbS"};